/**
 * ПУБЛИЧНЫЙ API модуля analytics — ЕДИНСТВЕННЫЙ вход для других модулей.
 *
 * ВАЖНО (коллизия имён): доменные типы в `analytics.types.ts`
 * (CargoFlow, CargoSubstitution, CargoRiskProfile, FinancialMetric,
 * GraphCluster, ForecastResult…) имеют ОДИНАКОВЫЕ имена, но ДРУГИЕ формы,
 * чем wire-DTO в `analytics.api.ts`. Публичной поверхностью являются
 * именно wire-DTO (как в старом @/hooks/useAnalytics). Поэтому здесь
 * реэкспортятся типы из ресурса (.api.ts), а доменные типы НЕ реэкспортятся
 * (они legacy-for-parity, никто из старого src/ их не импортил).
 */

// Общий UI-компонент вкладки «Аномалии» (используется /analytics и /cases).
export { AnomaliesView } from './components/anomalies-view'

export {
  useAnomalies,
  useForecast,
  useCargoIntelligence,
  useFinancialMetrics,
  useKpis,
  useRecommendationsAnalytics,
  useGenerateRecommendations,
  useRecommendationFeedback,
  useSchemes,
  useGraphData,
  useGraphClusters,
  useGraphFeatures,
  analyticsKeys,
} from './analytics.hooks'

export type {
  AnomaliesParams,
  ForecastParams,
  RecommendationsParams,
  GenerateRecommendationsParams,
  RecommendationFeedbackBody,
  SchemesParams,
  GraphParams,
  GraphClustersParams,
  GraphFeaturesParams,
  GraphAnalyzeResponse,
  GraphAnalyzeNode,
  GraphCluster,
  GraphClustersListResponse,
  GraphClustersListItem,
  GraphFeaturesResponse,
  RecommendationItem,
  RecommendationsResponse,
  KpiResponse,
  KpiItem,
  AnomaliesResponse,
  AnomalyItem,
  ForecastResponse,
  ForecastPoint,
  ForecastTrend,
  CargoResponse,
  CargoRiskProfile,
  CargoSubstitution,
  CargoFlow,
  CargoRoute,
  FinancialResponse,
  FinancialMetric,
  FinancialRegion,
} from './analytics.api'
